module.exports = __webpack_public_path__ + "img/funds-are-secured.c1099987.png";